import { Fragment } from 'react'

import BasicAlgebra from '~/components/Drill/DrillTopicsList/BasicAlgebra'
import Equations from '~/components/Drill/DrillTopicsList/Equations'
import Factorization from '~/components/Drill/DrillTopicsList/Factorization'
import Fractions from '~/components/Drill/DrillTopicsList/Fractions'
import Functions from '~/components/Drill/DrillTopicsList/Functions'
import Parentheses from '~/components/Drill/DrillTopicsList/Parentheses'
import Percent from '~/components/Drill/DrillTopicsList/Percent'
import Powers from '~/components/Drill/DrillTopicsList/Powers'
import TheMultiplicationTable from '~/components/Drill/DrillTopicsList/TheMultiplicationTable'

import { DRILL_TOPIC_TITLES } from '~/shared/constants/drill.const'
import { EventStatus, EventType } from '~/gamification/types/gamification.types'
import { QUIZ_SUBJECT } from '~/types/homebaseQuiz.types'
import { selectEvents } from '~/gamification/slices/gamification.slice'
import { useAppSelector } from '~/redux/hooks'

export default function DrillTopicListElementRenderer({
  path,
  title,
}: {
  path: string
  title: string
}): React.ReactElement {
  const matchableTitle = path
  const events = useAppSelector(selectEvents)
  function didCompleteAllDrillsForTopic(questId: QUIZ_SUBJECT): boolean {
    return Boolean(
      events?.find(
        (event) =>
          event.id === questId &&
          event.type === EventType.QUEST &&
          (event.status === EventStatus.DIALOGUE ||
            event.status === EventStatus.COMPLETED ||
            event.status === EventStatus.TROPHY_DIALOGUE),
      ),
    )
  }

  switch (true) {
    case DRILL_TOPIC_TITLES.BASIC_ALGEBRA.includes(matchableTitle): {
      const completed = didCompleteAllDrillsForTopic(QUIZ_SUBJECT.BASIC_ALGEBRA)
      return <BasicAlgebra completed={completed} path={path} title={title} />
    }

    case DRILL_TOPIC_TITLES.EQUATIONS.includes(matchableTitle): {
      const completed = didCompleteAllDrillsForTopic(QUIZ_SUBJECT.EQUATIONS)
      return <Equations completed={completed} path={path} title={title} />
    }

    case DRILL_TOPIC_TITLES.FACTORIZATION.includes(matchableTitle): {
      const completed = didCompleteAllDrillsForTopic(QUIZ_SUBJECT.FACTORIZATION)
      return <Factorization completed={completed} path={path} title={title} />
    }

    case DRILL_TOPIC_TITLES.FRACTIONS.includes(matchableTitle): {
      const completed = didCompleteAllDrillsForTopic(QUIZ_SUBJECT.FRACTIONS)
      return <Fractions completed={completed} path={path} title={title} />
    }

    case DRILL_TOPIC_TITLES.FUNCTIONS.includes(matchableTitle): {
      const completed = didCompleteAllDrillsForTopic(QUIZ_SUBJECT.FUNCTIONS)
      return <Functions completed={completed} path={path} title={title} />
    }

    case DRILL_TOPIC_TITLES.PARENTHESES.includes(matchableTitle): {
      const completed = didCompleteAllDrillsForTopic(QUIZ_SUBJECT.PARENTHESES)
      return <Parentheses completed={completed} path={path} title={title} />
    }

    case DRILL_TOPIC_TITLES.PERCENT.includes(matchableTitle): {
      const completed = didCompleteAllDrillsForTopic(QUIZ_SUBJECT.PERCENT)
      return <Percent completed={completed} path={path} title={title} />
    }

    case DRILL_TOPIC_TITLES.POWERS.includes(matchableTitle): {
      const completed = didCompleteAllDrillsForTopic(QUIZ_SUBJECT.POWERS)
      return <Powers completed={completed} path={path} title={title} />
    }

    case DRILL_TOPIC_TITLES.THE_MULTIPLICATION_TABLE.includes(matchableTitle): {
      const completed = didCompleteAllDrillsForTopic(QUIZ_SUBJECT.THE_MULTIPLICATION_TABLE)
      return <TheMultiplicationTable completed={completed} path={path} title={title} />
    }

    default:
      return <Fragment />
  }
}
